// extracted by mini-css-extract-plugin
export default {"mapWrapper":"Map_mapWrapper__M0vs8","locationLabel":"Map_locationLabel__B5v2D"};